import { TextField } from "@commonlibs";
import styled from "styled-components";

export const PhoneNumberField = styled(TextField)(() => ({
    flex: 1,
}));
